import { DatePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { CardContent } from '@models/card-content';
import { EllipsisPipe } from '@shared/pipes/ellipsis.pipe';

/**
 * basic riege card component to display content based on data
 * provided as an input object defined in type {@link CardContent}
 * the card template offers an `action-slot` to project any content
 * into the card actions container. To render that container it is required
 * to set an optional `action` flag.
 * @class CardComponent
 * @typedef {CardComponent}
 */
@Component( {
    selector: 'riege-card',
    imports: [
        MatCardModule,
        MatChipsModule,
        MatIconModule,
        NgTemplateOutlet,
        RouterLink,
        NgClass,
        DatePipe,
        EllipsisPipe
    ],
    templateUrl: './card.component.html',
    styleUrl: './card.component.scss',
    viewProviders: [ DatePipe, EllipsisPipe ]
} )
export class CardComponent {
    /** data to display in card */
    readonly data = input.required<CardContent>();
    readonly classes = input<string[]>();
}
